import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import * as moment from "moment-timezone";
import { Moment } from "moment-timezone";

export const maxDateValidator = (maxDate: Moment): ValidatorFn =>
    (control: AbstractControl): ValidationErrors | null => {
        if (maxDate && control.value) {
            const singleDateIsInvalid = moment.isMoment(control.value) && control.value.isAfter(maxDate);
            const rangeIsInvalid = control.value.end && control.value.end.isAfter(maxDate);
            if (singleDateIsInvalid || rangeIsInvalid) {
                return {
                    maxDate: {
                        spsLabelErrorMessage: "Selected date is after the latest allowed date."
                    }
                };
            }
        }
        return null;
    };
